import { render, staticRenderFns } from "./PreloadAppScreen.vue?vue&type=template&id=93c23610&scoped=true&"
import script from "./PreloadAppScreen.vue?vue&type=script&lang=ts&"
export * from "./PreloadAppScreen.vue?vue&type=script&lang=ts&"
import style0 from "./PreloadAppScreen.vue?vue&type=style&index=0&id=93c23610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c23610",
  null
  
)

export default component.exports